/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./ExpandedTech.css";
import cataloguesIcon from "../../../Assets/Icons/cataloges-icon.svg";
import htmlIcon from "../../../Assets/Icons/web-html-icon.svg";
import nodejsIcon from "../../../Assets/Icons/web-nodejs-icon.svg";
import cssIcon from "../../../Assets/Icons/web-css-icon.svg";
import dotnetIcon from "../../../Assets/Icons/web-dotnet-icon.svg";
import blazorIcon from "../../../Assets/Icons/web-blazor-icon.svg";
import reactIcon from "../../../Assets/Icons/web-react-icon.svg";
import pythonIcon from "../../../Assets/Icons/web-python-icon.svg";
import typescriptIcon from "../../../Assets/Icons/web-typescript-icon.svg";
import arrowRightIcon from "../../../Assets/Icons/arrow-right-icon.svg";
import mobJavaIcon from "../../../Assets/Icons/mob-java-icon.svg";
import mobXamarinIcon from "../../../Assets/Icons/mob-xamarin-icon.svg";
import mobFlutterIcon from "../../../Assets/Icons/mob-flutter-icon.svg";
import mobSwiftIcon from "../../../Assets/Icons/mob-swift-icon.svg";
import mobReactIcon from "../../../Assets/Icons/mob-react-icon.svg";
import mobObjCIcon from "../../../Assets/Icons/mob-objc-icon.svg";
import uiPhotoshopIcon from "../../../Assets/Icons/ui-photoshop-icon.svg";
import uiIllustratorIcon from "../../../Assets/Icons/ui-illustrator-icon.svg";
import uiSketchIcon from "../../../Assets/Icons/ui-sketch-icon.svg";
import uiFigmaIcon from "../../../Assets/Icons/ui-figma-icon.svg";
import uiXdIcon from "../../../Assets/Icons/ui-xd-icon.svg";
import uiFramerIcon from "../../../Assets/Icons/ui-framer-icon.svg";
import cloudAws from "../../../Assets/Icons/cloud-aws.svg";
import cloudAzure from "../../../Assets/Icons/cloud-azure.svg";
import cloudVercel from "../../../Assets/Icons/cloud-vercel.svg";
import cloudDigitalOcean from "../../../Assets/Icons/cloud-digital-ocean.svg";
import cloudFirebase from "../../../Assets/Icons/cloud-firebase.svg";
import cloudHeroku from "../../../Assets/Icons/cloud-heroku.svg";
import dbMySql from "../../../Assets/Icons/db-my-sql.svg";
import dbSqLite from "../../../Assets/Icons/db-sq-lite.svg";
import dbMsSql from "../../../Assets/Icons/db-ms-sql.svg";
import dbMongoDb from "../../../Assets/Icons/db-mongodb.svg";
import dbPostSql from "../../../Assets/Icons/db-postsql.svg";
import dbRedis from "../../../Assets/Icons/db-redis.svg";

const ExpandedTech = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(null);

  const techCategories = [
    "Web Technology",
    "Mobile Technology",
    "UX&UI Design",
    "Cloud",
    "Database",
  ];

  const techData = {
    "Web Technology": [
      { name: "HTML", icon: htmlIcon },
      { name: "Node.JS", icon: nodejsIcon },
      { name: "CSS", icon: cssIcon },
      { name: "Microsoft .NET", icon: dotnetIcon },
      { name: "Blazor", icon: blazorIcon },
      { name: "React", icon: reactIcon },
      { name: "Python", icon: pythonIcon },
      { name: "TypeScript", icon: typescriptIcon },
    ],
    "Mobile Technology": [
      { name: "Java", icon: mobJavaIcon },
      { name: "Xamarin", icon: mobXamarinIcon },
      { name: "Flutter", icon: mobFlutterIcon },
      { name: "Swift", icon: mobSwiftIcon },
      { name: "React", icon: mobReactIcon },
      { name: "Objective-C", icon: mobObjCIcon },
    ],
    "UX&UI Design": [
      { name: "Photoshop", icon: uiPhotoshopIcon },
      { name: "Illustrator", icon: uiIllustratorIcon },
      { name: "Sketch", icon: uiSketchIcon },
      { name: "Figma", icon: uiFigmaIcon },
      { name: "Adobe XD", icon: uiXdIcon },
      { name: "Framer", icon: uiFramerIcon },
    ],
    Cloud: [
      { name: "AWS", icon: cloudAws },
      { name: "Azure", icon: cloudAzure },
      { name: "Vercel", icon: cloudVercel },
      { name: "Digital Ocean", icon: cloudDigitalOcean },
      { name: "Firebase", icon: cloudFirebase },
      { name: "Heroku", icon: cloudHeroku },
    ],
    Database: [
      { name: "MySQL", icon: dbMySql },
      { name: "SQLite", icon: dbSqLite },
      { name: "MS SQL", icon: dbMsSql },
      { name: "MongoDB", icon: dbMongoDb },
      { name: "Postgre SQL", icon: dbPostSql },
      { name: "Redis", icon: dbRedis },
    ],
  };

  const categoryToPath = {
    "Web Technology": "/technologies/web",
    "Mobile Technology": "/technologies/mobile",
    "UX&UI Design": "/technologies/ui-ux",
    Cloud: "/technologies/cloud",
    Database: "/technologies/database",
  };

  const location = useLocation();

  const pathToCategory = Object.keys(categoryToPath).reduce((acc, key) => {
    acc[categoryToPath[key]] = key;
    return acc;
  }, {});

  useEffect(() => {
    const currentPath = location.pathname;
    const matchedCategory = pathToCategory[currentPath];
    if (matchedCategory) {
      setActiveCategory(matchedCategory);
    } else {
      setActiveCategory("Web Technology");
    }
  }, [location.pathname]);

  const currentTechIcons = techData[activeCategory] || [];

  const handleCategoryClick = (category) => {
    const path = categoryToPath[category];
    if (path) {
      navigate(path);
    }
  };

  const blueBackgroundRoutes = [
    "/services/software-consulting",
    "/career",
    "/contact-us",
    "/contact-us/hiring-team",
    "/contact-us/build-business",
    "/blog1",
    "/blog2",
    "/blog3",
    "/technologies",
    "/technologies/web",
    "/technologies/mobile",
    "/technologies/ui-ux",
    "/technologies/cloud",
    "/technologies/database",
  ];

  const isBlueBackground = blueBackgroundRoutes.includes(location.pathname);

  return (
    <div
      className={`expanded-tech ${
        isBlueBackground ? "expanded-tech--high-opacity" : ""
      }`}
    >
      <div className="expanded-tech__content">
        {/* Left Column */}
        <div className="expanded-tech__left">
          <Link
            to="/technologies"
            className="expanded-tech__techonologies-link"
          >
            <div className="expanded-tech__title">
              <img
                src={cataloguesIcon}
                alt="Technologies"
                className="expanded-tech__icon"
              />
              <h3 className="expanded-tech__heading">
                Our Technologies & Frameworks
              </h3>
            </div>
          </Link>
          <p className="expanded-tech__description">
            Our Developers team are using The Latest technologies and
            frameworks.
          </p>
        </div>

        {/* Middle Column */}
        <div className="expanded-tech__middle">
          <ul className="expanded-tech__category-list">
            {techCategories.map((cat) => (
              <li
                key={cat}
                className={`expanded-tech__category-item ${
                  cat === activeCategory
                    ? "expanded-tech__category-item--active"
                    : ""
                }`}
                onMouseEnter={() => setActiveCategory(cat)}
                onClick={() => handleCategoryClick(cat)}
              >
                <span className="expanded-tech__category-name">{cat}</span>
                <img
                  src={arrowRightIcon}
                  alt="View technologies"
                  className="expanded-tech__arrow-icon"
                />
              </li>
            ))}
          </ul>
        </div>

        {/* Right Column */}
        <div className="expanded-tech__right">
          <div className="expanded-tech__grid">
            {Array.from({ length: Math.ceil(currentTechIcons.length / 4) }).map(
              (_, rowIndex) => {
                const rowItems = currentTechIcons.slice(
                  rowIndex * 4,
                  rowIndex * 4 + 4,
                );
                const paddedRow = [...rowItems];
                while (paddedRow.length < 4) {
                  paddedRow.push(null);
                }

                return (
                  <div key={rowIndex} className="expanded-tech__row">
                    {paddedRow.map((tech, idx) => {
                      if (!tech) {
                        return (
                          <div
                            key={`empty-${rowIndex}-${idx}`}
                            className="expanded-tech__item-placeholder"
                          ></div>
                        );
                      }
                      return (
                        <div
                          key={`${rowIndex}-${idx}`}
                          className="expanded-tech__item"
                        >
                          <img
                            src={tech.icon}
                            alt={tech.name}
                            className="expanded-tech__tech-icon"
                          />
                          <span className="expanded-tech__tech-name">
                            {tech.name}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                );
              },
            )}
            {/* <div className="expanded-tech__footer">
              <button
                type="button"
                onClick={() => handleCategoryClick(activeCategory)}
                className="expanded-tech__see-details-link"
                aria-label={`View details for ${activeCategory}`}
              >
                See Details
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpandedTech;
